import { Slide, toast } from "react-toastify";

export const datePickerFormat = (value) => {
  if (value == null || value.length < 8) {
    return value;
  }
  const dateString = value.toString();
  const Parts = dateString.split(" ");
  const keepOnlyDate = Parts.slice(0, 4).join(" ");

  const parts = keepOnlyDate.split(" ");
  const monthMap = {
    "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04", "May": "05", "Jun": "06",
    "Jul": "07", "Aug": "08", "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
  };
  const formattedDate = `${monthMap[parts[1]]}/${parts[2]}/${parts[3]}`;
  return formattedDate
};

export const notify = (
  type = "success",
  message = "",
  visibleTimeInSeconds = 2
) => {
  let waitTime = visibleTimeInSeconds * 1000;
  const options = {
    position: "top-right",
    autoClose: waitTime,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: Slide,
  };

  if (type === "success") {
    toast.success(message, { ...options, className: 'custom-toast-success' });
  } else {
    toast.error(message, options);
  }
};

export const convertToUrl = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
};

export const usPhoneFormat = (phone) => {
  if (phone?.includes('+1')) {
    phone = phone?.replace('+1', '');
  }

  const cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phone;
};